import React from 'react';
import PropTypes from 'prop-types';
import Stack from '@mui/material/Stack';

const ConditionalBorderStack = ({ id, showBorder, onConditionalClick, minHeight, children }) => (
  <Stack
    id={id}
    flexDirection="column"
    justifyContent="space-between"
    sx={{
      borderRadius: 5,
      border: '1px solid',
      borderColor: showBorder ? 'error.A800' : 'divider',
      cursor: 'pointer',
      minHeight,
    }}
    onClick={onConditionalClick}
  >
    {children}
  </Stack>
);

ConditionalBorderStack.propTypes = {
  id: PropTypes.string.isRequired,
  showBorder: PropTypes.bool.isRequired,
  onConditionalClick: PropTypes.func,
  children: PropTypes.node.isRequired,
  minHeight: PropTypes.number,
};

ConditionalBorderStack.defaultProps = {
  onConditionalClick: null,
  minHeight: null,
};

export default ConditionalBorderStack;
